export enum FilterActionTypes {
  SET_FILTER_INPUT = "SET_FILTER_INPUT",
  SET_FILTER_LOCATION_CITY = "SET_FILTER_LOCATION_CITY",
  SET_FILTER_LOCATION_DISTRICT = "SET_FILTER_LOCATION_DISTRICT",
  SET_FILTER_AREA = "SET_FILTER_AREA",
  SET_FILTER_ROI = "SET_FILTER_ROI",
  SET_FILTER_VGV = "SET_FILTER_VGV",
}
